import React from 'react';
import {useEffect, useState} from 'react';
import {Route, useNavigate} from 'react-router-dom';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import {useAuthentication} from '../auth/hooks/useAuthentication';

/**
 * A route component that renders its children if the user is subscribed.
 * Redirects to a subscription choice page if the user is not subscribed.
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to render.
 * @returns {React.ReactNode|null} The rendered children or null if the user is not subscribed.
 */
const SubscribedRoute = ({children}) => {
  const {profil} = useUserInfo();
  const {isAuthenticated, isLoading, token} = useAuthentication();
  const navigate = useNavigate();
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    console.log('profil', profil);
    if (profil && profil.subscriptionStatus === 'active' && isAuthenticated) {
      setIsSubscribed(true);
    } else if (profil && isAuthenticated && token) {
      navigate('/subscription-choice');
    }
  }, [isAuthenticated, profil]);

  return isAuthenticated && isSubscribed && !isLoading && children;
};

export default SubscribedRoute;
